export default {
  initMenu(state, menus){
    state.routes = menus;
  },
  login(state, user){
    state.user = user;
    window.localStorage.setItem('user', JSON.stringify(user));
  },
  logout(state){
    window.localStorage.clear();
    state.routes = [];
    state.user.id='';
    state.user.remark='';
  },
//    toggleNFDot(state, newValue){
//      state.nfDot = newValue;
//    },
//    updateMsgList(state, newMsgList){
//      state.msgList = newMsgList;
//    },
//    updateCurrentFriend(state, newFriend){
//      state.currentFriend = newFriend;
//    },
//    addValue2DotMap(state, key){
//      state.isDotMap.set(key, "您有未读消息")
//    },
//    removeValueDotMap(state, key){
//      state.isDotMap.delete(key);
//    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js